import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AppVersion } from 'src/app/model/appVersion';

@Component({
  selector: 'app-status-overview',
  templateUrl: './status-overview.component.html',
  styleUrls: ['./status-overview.component.scss'],
  providers: [DatePipe],
})
export class StatusOverviewComponent {
  @Input() appVersions: AppVersion[];

  constructor(private readonly datePipe: DatePipe) {}

  updateStatusImage(item: AppVersion, section: string) {
    const success = '../../../../assets/images/icons/success.svg';
    const failure = '../../../../assets/images/icons/Icon-Alert-Error.svg';
    const loading = '../../../assets/images/icons/loading.png';
    const published = '../../../../assets/images/icons/ok-hand.svg';

    if (!item[section].status) {
      return '';
    }

    if (item[section].status === 'PROGRESS') {
      return loading;
    }

    if (item[section].status === 'SUCCESS') {
      return success;
    }

    if (item[section].status === 'FAILURE') {
      return failure;
    }

    if (item[section].status === 'PUBLISHED') {
      return published;
    }

    return '';
  }

  showStatusBar(item: AppVersion): boolean {
    return item.request_publication.status === 'PUBLISHED';
  }

  showLoading(item: AppVersion, section: string) {
    return {
      loading: item[section].status === 'PROGRESS',
      published:
        section === 'request_publication' &&
        item[section].status === 'PUBLISHED',
    };
  }

  toolTipMessage(item: AppVersion, section: string) {
    if (item[section].info) {
      const date = item[section].date
        ? this.datePipe.transform(item[section].date)
        : '';

      return date + ' ' + item[section].info;
    }

    return section;
  }
}
